module.exports = __webpack_public_path__ + "img/ylands_generic_background_wireframing_2.8ccf36ca.png";